import { AddAttachmentPayload, User } from '@certhon/models';
import { EventActions } from '../EventActions';
import { AttachmentContent } from './AttachmentContent';
import { LocationContent } from './LocationContent';
import { MessageContent } from './MessageContent';
import { TimelineEntry } from './TimelineEntry';
import { ExtendedTicketEvent } from './timeline-utils';

export function EventItem({
  event,
  isGroupStart,
  isLastEvent,
  previousTimestamp,
  onEdit,
  onDelete,
  onDownload,
  onOpenInLightbox,
  currentUserId,
  user,
  isEditing,
  onUpdateMessage,
  onCancelEdit,
}: {
  event: ExtendedTicketEvent;
  isGroupStart: boolean;
  isLastEvent: boolean;
  previousTimestamp?: Date;
  onEdit?: () => void;
  onDelete?: () => void;
  onDownload?: (attachment: AddAttachmentPayload) => void;
  onOpenInLightbox?: (attachment: AddAttachmentPayload) => void;
  currentUserId?: number;
  user: User;
  isEditing?: boolean;
  onUpdateMessage?: (eventId: string, message: string) => void;
  onCancelEdit?: () => void;
}) {
  const canEdit =
    currentUserId === event.user_id && event.type !== 'TICKET_REFERENCE';
  const canDelete =
    currentUserId === event.user_id && event.type !== 'TICKET_REFERENCE';

  const eventActions =
    event.type !== 'TICKET_REFERENCE' ? (
      <EventActions
        event={event}
        onEdit={onEdit}
        onDelete={onDelete}
        onDownload={onDownload}
        canEdit={canEdit}
        canDelete={canDelete}
      />
    ) : null;

  return (
    <TimelineEntry
      event={event}
      user={user}
      isGroupStart={isGroupStart}
      isLastEvent={isLastEvent}
      previousTimestamp={previousTimestamp}
      eventActions={eventActions}
    >
      {event.type === 'ADD_MESSAGE' && (
        <MessageContent
          event={event}
          isEditing={isEditing}
          onUpdateMessage={onUpdateMessage}
          onCancelEdit={onCancelEdit}
        />
      )}

      {event.type === 'ADD_ATTACHMENT' && (
        <AttachmentContent
          event={event}
          onDownload={onDownload}
          onOpenInLightbox={onOpenInLightbox}
        />
      )}

      {event.type === 'ADD_LOCATION' && <LocationContent event={event} />}
    </TimelineEntry>
  );
}
